import $axios from "@/plugins/axios";
const common = {
    GetOrgList: params => $axios.post('Public/GetOrgList', params),
    GetFastUrl: params => $axios.post3('Public/GetFastUrl', params),
}
export default common;